exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  font-family: 'Roboto', sans-serif;\n  font-size: 30px;\n  font-weight: 300;\n}\n\na {\n  font-family: 'Roboto', sans-serif;\n  font-size: 22px;\n  font-weight: 100;\n  color: #eeddbb;\n  text-decoration: none;\n}\n\na span {\n  cursor: pointer;\n  display: inline-block;\n  position: relative;\n  transition: 0.2s;\n}\n\na span:after{\n  content: '\\BB';\n  position: absolute;\n  opacity: 0;\n  top: 0;\n  right: -20px;\n  transition: 0.5s;\n}\n\na:hover span {\n  padding-right: 25px;\n}\n\na:hover span:after {\n  opacity: 1;\n  right: 0;\n}\n\n.row.title {\n  margin-top: 20px;\n  margin-bottom: 40px;\n}\n\n.row.link {\n  margin-top: 10px;\n  margin-bottom: 15px;\n}\n\n.menu {\n  padding: 5px;\n}\n\n.active {\n  background-color: #ccbb99;\n  /*color: black;*/\n}\n\n.active > [class*='col-'] > a {\n  color: black;\n  font-weight: 300;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/side-menu/side-menu.component.css
// module id = ../../../../../src/app/side-menu/side-menu.component.css
// module chunks = main